import { jsx as _jsx } from "react/jsx-runtime";
import { OktaContext } from '@okta/okta-react';
import { useLocationHash, useLocationPathname, useLocationSearch, useLocationState, Navigate } from '@rocketlane/rocket-router';
import React, { useContext } from 'react';
import { PageLoading } from 'components/atoms/loading';
import { RoutePaths } from 'constant';
// import { useFieldsLoaded } from 'hooks/use-fields-loaded';
import { useCustomAuth } from 'hooks/use-custom-auth';
const StableRouteChildren = /*#__PURE__*/ React.memo(function StableRouteChildren({ children }) {
    return children;
}, (prev, next)=>prev.children === next.children);
StableRouteChildren.displayName = 'StableRouteChildren';
/**
 * Only mounts when redirecting to login. Uses pathname/search/hash/state for Navigate.
 * Isolated so hash changes don't re-render the authenticated route tree.
 */ const RedirectToLogin = ({ onAuthRequired })=>{
    const oktaContext = useContext(OktaContext);
    const oktaAuth = oktaContext === null || oktaContext === void 0 ? void 0 : oktaContext.oktaAuth;
    const pathname = useLocationPathname();
    const search = useLocationSearch();
    const hash = useLocationHash();
    const state = useLocationState();
    if (onAuthRequired) {
        onAuthRequired();
    } else if (oktaAuth) {
        oktaAuth.signInWithRedirect({
            originalUri: pathname
        });
    }
    return /*#__PURE__*/ _jsx(Navigate, {
        to: RoutePaths.login,
        state: {
            from: {
                pathname,
                search,
                hash,
                state
            }
        }
    });
};
/**
 * SecureRoute shell: uses only authState. When authenticated, renders children
 * without subscribing to hash/search/state — so task drawer open/close (hash-only)
 * does NOT cause re-renders.
 */ export const SecureRoute = ({ children, ...rest })=>{
    const oktaContext = useContext(OktaContext);
    const { isAuthenticated: customIsAuthenticated } = useCustomAuth();
    const authState = oktaContext ? oktaContext.authState : {
        isAuthenticated: customIsAuthenticated
    };
    const { onAuthRequired } = rest;
    if (!authState) {
        // eslint-disable-next-line @calm/react-intl/missing-formatted-message
        return /*#__PURE__*/ _jsx("div", {
            children: "Loading..."
        });
    }
    if (!authState.isAuthenticated) {
        return /*#__PURE__*/ _jsx(RedirectToLogin, {
            onAuthRequired: onAuthRequired
        });
    }
    return /*#__PURE__*/ _jsx(StableRouteChildren, {
        children: children
    });
};
export const CustomSecureRoute = (props)=>{
    const { isLoading } = props;
    return isLoading ? /*#__PURE__*/ _jsx(PageLoading, {
        css: true
    }) : // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ _jsx(SecureRoute, {
        ...props,
        children: props === null || props === void 0 ? void 0 : props.children
    });
};
